import Vue from 'vue';
import GsDialog from '../components/gs/gsDialog/index';
import GsButtonIcon from '../components/gs/gsButtonIcon';
import GsButtonGroup from '../components/gs/gsButtonGroup';
import GsDivider from '../components/gs/gsDivider';
import GsTree from '../components/gs/gsTree';
import GsTreeNode from '../components/gs/gsTreeNode';

Vue.use(GsDialog);
Vue.use(GsButtonIcon);
Vue.use(GsButtonGroup)
Vue.use(GsDivider);
Vue.use(GsTree);
Vue.use(GsTreeNode);
